import http from 'plugins/axios';

export default {
    reqList(data) {
        return http.get({
            url: '/admin/incubator/airDrop/list/task',
            data
        });
    },
    create(data) {
        return http.post({
            url: '/admin/incubator/airDrop/createTask',
            data,
            dataType: 'form'
        });
    },
    reqAirDrops(data) {
        return http.get({
            url: '/admin/incubator/airDrop/list/airdrop',
            data
        });
    },
    checkAirDrop(data) {
        return http.post({
            url: '/admin/incubator/airDrop/checked/airdrop',
            data,
            dataType: 'form'
        });
    },
    importAirDrop(data) {
        return http.post({
            url: '/admin/incubator/airDrop/save/airdrop',
            data,
            dataType: 'form'
        });
    },
    executeAirDrop(data) {
        return http.post({
            url: '/admin/incubator/airDrop/executeAirDrop',
            data,
            dataType: 'form'
        });
    }

};
